import { DeleteButton, GridColumns, Stack } from "@pankod/refine-mui";

export const productColumns: GridColumns = [
  {
    field: "product",
    headerName: "Producto",
    flex: 1,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      return params.row.product.code + " - " + params.row.product.name;
    },
  },
  {
    field: "quantity_pieces",
    headerName: "Cantidad Piezas",
    flex: 1,
    sortable: false,
    filterable: false,
  },
  {
    field: "weight_pieces",
    headerName: "Peso Piezas",
    flex: 1,
    sortable: false,
    filterable: false,
  },
  {
    headerName: "Acciones",
    headerAlign: "center",
    field: "actions",
    minWidth: 180,
    align: "center",
    flex: 1,
    renderCell: function render({ row }) {
      return (
        <Stack direction="row" spacing={1}>
          <DeleteButton
            size="small"
            hideText
            onClick={() => row.delete(row.id)}
          />
        </Stack>
      );
    },
  },
];

export const materialColumns: GridColumns = [
  {
    field: "material",
    headerName: "Material",
    flex: 1,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      return params.row.material.code + " - " + params.row.material.name;
    },
  },
  {
    field: "delivered_weight",
    headerName: "Peso Entregado",
    flex: 1,
    sortable: false,
    filterable: false,
  },
  {
    headerName: "Acciones",
    headerAlign: "center",
    field: "actions",
    minWidth: 180,
    align: "center",
    flex: 1,
    renderCell: function render({ row }) {
      return (
        <Stack direction="row" spacing={1}>
          <DeleteButton
            size="small"
            hideText
            onClick={() => row.delete(row.id)}
          />
        </Stack>
      );
    },
  },
];
